<template>
	<div class="swipe-container" :cardbg="cardbg">
		<v-touch
				@panstart=""
				@panmove="onPan"
				@panend="onPanEnd"
				class="swipe-container__touch"
				:class="addedClass"
		>
			<div class="question">
				<div class="question__header"><p>{{header}}</p></div>
				<img draggable="false" :src="image" class="swipe-container__image"/>
				<div class="question__text">
					<p>{{questiontext}}</p>
				</div>
			</div>
		</v-touch>
				
	</div>
</template>

<script>

	import Velocity from 'velocity-animate';

export default {

	props:[
		'cardbg',
		'image',
		'onanswer',
		'deadZone',
		'questiontext',
		'header'
	],

	mounted(){
		$('.swipe-container').css('background-image', 'url("'+this.cardbg+'")')
		$('.swipe-container__image').on('dragstart', function (e) {e.preventDefault();});
	},

	data(){
		return{
			addedClass: "",
		}
	},
	methods:{
		onPan(e){

			let el = this.$el.querySelector('.swipe-container__touch');
			let img = this.$el.querySelector('.swipe-container__image');

			let vertical = e.deltaY;
			let horizontal = e.deltaX;
			if(vertical > 0) vertical = 0;

			if(Math.abs(e.deltaX) > Math.abs(e.deltaY)){
				el.style.transform = "translate("+horizontal+"px,0px)";
			}
			else{
				el.style.transform = "translate(0px,"+vertical+"px)";
			}


			if(Math.abs(e.deltaX) < this.deadZone && Math.abs(e.deltaY) < this.deadZone){
				el.className = 'swipe-container__touch';
				//el.style.border = "2px solid #fff";
				return;
			}

			if(Math.abs(e.deltaX) > Math.abs(e.deltaY)){
				if(e.deltaX > 0){
					el.className = 'swipe-container__touch swiperight';
					//el.style.border = "5px solid #95d934";
				}
				else if(e.deltaX < 0){
					el.className = 'swipe-container__touch swipeleft';
					//el.style.border = "5px solid #cc0000";
				}
			}
			else{
				el.className = 'swipe-container__touch swipeup';
				//el.style.border = "5px solid #ff9900";
			}

		},

		onPanEnd(e){

			let el = this.$el.querySelector('.swipe-container__touch');
			let img = this.$el.querySelector('.swipe-container__image');

			el.className = 'swipe-container__touch';
			//el.style.border = "0px solid #fff";

			if(Math.abs(e.deltaX) < this.deadZone && Math.abs(e.deltaY) < this.deadZone){
				el.style.transform = "translate(0px,0px)";
				return;
			}

			let answer = "Dont know";

			if(Math.abs(e.deltaX) > Math.abs(e.deltaY)){
				if(e.deltaX > 0){
					answer = "Yes";
					this.moveAway(el , 500,0);
				}
				else if(e.deltaX < 0){
					answer = "No";
					this.moveAway(el , -500,0);
				}
			}
			else{
				this.moveAway(el , 0,-1000);
			}

			setTimeout(() =>
			{
				this.$emit("onanswer" , answer);
				el.style.left = 0;
				el.style.top = 0;
				el.style.opacity = 1;
				el.style.transform = "translate(0px,0px)";
			}, 800);
		},

		moveAway (el , left , top) {
			el.style.opacity = 1;
			Velocity(el,
				{
					opacity: 0,
					left: left,
					top: top
				},
				{
					duration:500,
					easing: [ 0.39, 0.67, 0.04, 0.98 ],
				}
			);
		},

	},

}
</script>


// WEBPACK FOOTER //
// src/components/minigames/swipequiz/SwipeImage.vue